import React from "react";
import { Link } from "react-router";
import { hasPermission } from "../auth/Auth";

export default class EditButton extends React.Component {

    render() {
      
        if (this.props.permission === true) {
           
        } else if (this.props.permission === false) {
            return <div style={{width: "19px", display: "inline-block"}}>&nbsp;</div>;
        } else {
            if (typeof this.props.permission !== "boolean" && !hasPermission(this.props.permission)) {
                return <div style={{width: "19px", display: "inline-block"}}>&nbsp;</div>;
            }
        }

        return (
            <Link to={this.props.to} className={this.props.className} style={{ marginRight: "5px" }}>
                <i className="fa fa-edit" />
            </Link>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/base/EditButton.js